import { i18n } from '@lt/localization';

import x30x30 from 'src/images/header_banner/headerBanner.png';
import webp_x30x30 from 'src/images/header_banner/headerBanner.webp';

export const defaultHeaderBanner = {
  title: i18n.t('headerBanner.title'),
  description: i18n.t('headerBanner.description'),
  desktopText: `${i18n.t('headerBanner.title')} ${i18n.t(
    'headerBanner.description',
  )}`,
  backgroundColor: '#009cd3',
  textColor: '#ffffff',
  redirectUrl:
    'https://promo.level.travel/fly-now?ref_source=internal&ref_medium=promo&ref_term=site&ref_content=desk-banner-long&ref_campaign=fly-now',
  imageSrc: {
    x30x30,
    webp_x30x30,
  },
};
